goog.provide("shadow.js.shim.module$$mui$material$DialogTitle");
goog.provide("module$shadow_js_shim_module$$mui$material$DialogTitle");
shadow.js.shim.module$$mui$material$DialogTitle = shadow.js.nativeProvides["@mui/material/DialogTitle"] = shadow$bridge("@mui/material/DialogTitle");
module$shadow_js_shim_module$$mui$material$DialogTitle.default = shadow.js.shim.module$$mui$material$DialogTitle;
